// Error Screen Component - Shows import errors
import { t } from '../../../i18n.js';

export class ErrorScreen {
  constructor(wizard) {
    this.wizard = wizard;
  }
  
  show(error) {
    const isAppointment = this.wizard.item.itemType === Office.MailboxEnums.ItemType.Appointment;
    const errorTitle = isAppointment ? t('error_adding_event') : t('error_adding_email');
    
    this.wizard.container.innerHTML = `
      <div class="error-screen">
        <div class="error-header">
          <span class="error-icon">⚠️</span>
          <h3>${errorTitle}</h3>
        </div>
        
        <div class="error-details">
          <p>${error.message}</p>
        </div>
        
        <div class="error-actions">
          <button onclick="window.location.reload()" class="wizard-btn wizard-btn-primary">
            ${t('try_again')}
          </button>
        </div>
      </div>
    `;
  }
}
